module.exports = __webpack_public_path__ + "img/aa6ef8a.jpg";